export default __webpack_public_path__ + "static/horizontal-45b5855b7f1f7cffee5d912c67a2d92e.png";